/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Button, InputGroup, Modal,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import BaseGrid from '../Common/BaseGrid';

function ListingMultiSelect(props) {
  // eslint-disable-next-line no-unused-vars
  const [items, setItems] = useState([]);

  const { onChange, t } = props;

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const handleAddItem = (lst) => {
    setItems([...items, { listing: lst, listing_id: lst.id, label: lst.condition }]);
    onChange([...items, { listing: lst, listing_id: lst.id, label: lst.condition }]);
  };

  return (
    <BaseGrid
      url="/api/listings"
      hasSearch
      shouldPaginate
      config={
      {
        columns: {
          thumb: {
            label: '',
            image: {
              src: (item) => (`/api/listings/thumbnail/${item.id}`),
              class: 'rounded',
              style: { maxHeight: '5rem', maxWidth: '5rem' },
            },
            translate: false,
          },
          id: { label: 'ID', sort: true },
          sku: { label: 'Sku', sort: true },
          actions: {
            label: props.t('Actions'),
            actions: [
              {
                key: 'select',
                icon: 'mdi mdi-check-bold',
                class: 'btn btn-sm btn-soft-dark',
                alt: props.t('Select'),
                condition: (listing) => {
                  for (let i = 0; i < items.length; i += 1) {
                    if (items[i].id === listing.id || items[i].listing_id === listing.id) {
                      return false;
                    }
                  }

                  return true;
                },
                click: (listing) => {
                  handleAddItem(listing);
                  toastr.success(props.t('Item added.'));
                },
              },

              {
                key: 'unselect',
                icon: 'mdi mdi-check-bold',
                class: 'btn btn-sm btn-soft-success',
                alt: props.t('Select'),
                condition: (listing) => {
                  for (let i = 0; i < items.length; i += 1) {
                    if (items[i].id === listing.id || items[i].listing_id === listing.id) {
                      return true;
                    }
                  }

                  return false;
                },
                click: (listing) => {
                  setItems(
                    items.filter(
                      (item) => item.id !== listing.id && item.listing_id !== listing.id,
                    ),
                  );
                  onChange(items.filter(
                    (item) => item.id !== listing.id && item.listing_id !== listing.id,
                  ));
                  toastr.warning(props.t('Item removed.'));
                },
              },
            ],
          },
        },
        pagination: {
          sort: 'id',
          direction: 'desc',
          perPage: 5,
        },
      }
      }
    />
  );
}

ListingMultiSelect.defaultProps = {
  t: (x) => (x),
};

ListingMultiSelect.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(ListingMultiSelect));
